<template>
    <div>
        <div v-if="hasError" class="error-boundary-fallback text-center p-5">
            <i class="fa fa-exclamation-triangle fa-3x text-warning mb-3"></i>
            <h4>{{ title }}</h4>
            <p class="text-muted">{{ message }}</p>
            <button class="btn btn-primary" @click="handleRetry">
                {{ retryLabel }}
            </button>
        </div>
        <slot v-else></slot>
    </div>
</template>

<script>
function translate(vm, key, fallback) {
    const translated = vm.$t(key)
    return translated && translated !== key ? translated : fallback
}

export default {
    name: 'ErrorBoundary',
    data() {
        return {
            hasError: false,
        }
    },
    computed: {
        title() {
            return translate(this, 'str.error.boundary.title', 'Algo deu errado')
        },
        message() {
            return translate(this, 'str.error.boundary.message', 'Ocorreu um erro inesperado ao carregar esta página. Tente recarregar.')
        },
        retryLabel() {
            return translate(this, 'str.error.boundary.retry', 'Recarregar')
        },
    },
    errorCaptured(err) {
        this.hasError = true
        const message = err && err.message ? String(err.message) : ''
        if (/Loading chunk|ChunkLoadError|Loading CSS chunk/i.test(message)) {
            window.location.reload()
        }
        return false
    },
    methods: {
        handleRetry() {
            window.location.reload()
        },
    },
}
</script>

<style scoped>
.error-boundary-fallback {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 300px;
}
</style>
